"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.remove = exports.add = exports.createUserInputNeededArtifact = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const createUserInputNeededArtifact = ({ referenceArtifact, }) => {
    return {
        id: (0, uuid_1.v4)(),
        type: 'userInputNeeded',
        configuration: {
            inputType: 'cashContext',
        },
        loanProductSlug: null,
        creditFacilitySlug: null,
        artifactDocumentId: referenceArtifact.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `userInputNeeded_${referenceArtifact.artifactSlug}`,
    };
};
exports.createUserInputNeededArtifact = createUserInputNeededArtifact;
// create a synthetic node userInputNeeded which goes between
// ManualBankAccountReport => userInputNeeded => cashBalancesFeedContext.
//
// for each artifact of type "ManualBankAccountReport"
//  1. create a new artifact of type "userInputNeeded"
//  2. create a new dependency between ManualBankAccountReport => userInputNeeded
//  3. create a new dependency between userInputNeeded => cashBalancesFeedContext
const add = (dbGraph) => {
    const manualBankAccountReports = utils.filterManualBankAccountReports(dbGraph);
    const cashBalanceContexts = utils.filterCashBalancesFeedContexts(dbGraph);
    const newDependencies = [];
    const newArtifacts = [];
    manualBankAccountReports.forEach((manualBankAccountReport) => {
        const userInputNeeded = (0, exports.createUserInputNeededArtifact)({
            referenceArtifact: manualBankAccountReport,
        });
        newArtifacts.push(userInputNeeded);
        newDependencies.push({
            inputArtifactId: manualBankAccountReport.id,
            outputArtifactId: userInputNeeded.id,
        });
        // find corresponding cashBalancesFeedContext for this manualBankAccountReport.
        const cashBalanceContext = cashBalanceContexts.find((cbc) => cbc.creditFacilitySlug === manualBankAccountReport.creditFacilitySlug &&
            cbc.artifactSlug ===
                `cashBalancesFeedContext_${manualBankAccountReport.creditFacilitySlug}`);
        (0, common_1.finleyAssert)(cashBalanceContext, `Expected cashBalanceContext for manualBankAccountReport: ${manualBankAccountReport.creditFacilitySlug}`);
        newDependencies.push({
            inputArtifactId: userInputNeeded.id,
            outputArtifactId: cashBalanceContext.id,
        });
    });
    return {
        dataTapes: [...dbGraph.dataTapes, ...newArtifacts],
        dataTapeDependencies: [...dbGraph.dataTapeDependencies, ...newDependencies],
    };
};
exports.add = add;
// remove all the userInputNeededNodes (for assginemnt) and their dependencies.
const remove = (dbGraph) => {
    const userInputNeededNodeIds = utils
        .filterUserInputNeededNodesCashBalanceContext(dbGraph)
        .map(({ id }) => id);
    // filter out userInputNeededNodes and their dependencies.
    const dataTapes = dbGraph.dataTapes.filter((dataTape) => !userInputNeededNodeIds.includes(dataTape.id));
    const dataTapeDependencies = dbGraph.dataTapeDependencies.filter((dataTapeDependency) => !userInputNeededNodeIds.includes(dataTapeDependency.inputArtifactId) &&
        !userInputNeededNodeIds.includes(dataTapeDependency.outputArtifactId));
    return {
        dataTapeDependencies,
        dataTapes,
    };
};
exports.remove = remove;
exports.syntheticProcess = {
    toDb: exports.add,
    fromDb: exports.remove,
};
//# sourceMappingURL=cashBalanceUserInput.js.map